import { ForgeProjectsEndpoint } from "./projects";
import { ForgeProjectContextsEndpoint } from "./project-contexts";
import { ForgeProjectMembersEndpoint } from "./project-members";
import { RequestExecutor } from "../../transport";
import { ForgeAgentsEndpoint } from "./agents";
import { ForgeArtifactsEndpoint } from "./artifacts";
import { ForgeIterationMessagesEndpoint } from "./iteration-messages";
import { ForgeParticipantsEndpoint } from "./participants";
import { ForgeProjectIterationsEndpoint } from "./project-iterations";
import { ForgeProjectInvitationsEndpoint } from "./project-invitations";

export class ForgesEndpoint {
  readonly projectAgents: ForgeAgentsEndpoint;
  readonly artifacts: ForgeArtifactsEndpoint;
  readonly iterationMessages: ForgeIterationMessagesEndpoint;
  readonly participants: ForgeParticipantsEndpoint;
  readonly projectContexts: ForgeProjectContextsEndpoint;
  readonly projectIterations: ForgeProjectIterationsEndpoint;
  readonly projectMembers: ForgeProjectMembersEndpoint;
  readonly projects: ForgeProjectsEndpoint;
  readonly projectInvitations: ForgeProjectInvitationsEndpoint;

  constructor(requestExecutor: RequestExecutor) {
    this.projectAgents = new ForgeAgentsEndpoint(requestExecutor);
    this.artifacts = new ForgeArtifactsEndpoint(requestExecutor);
    this.iterationMessages = new ForgeIterationMessagesEndpoint(requestExecutor);
    this.participants = new ForgeParticipantsEndpoint(requestExecutor);
    this.projectContexts = new ForgeProjectContextsEndpoint(requestExecutor);
    this.projectIterations = new ForgeProjectIterationsEndpoint(requestExecutor);
    this.projectMembers = new ForgeProjectMembersEndpoint(requestExecutor);
    this.projects = new ForgeProjectsEndpoint(requestExecutor);
    this.projectInvitations = new ForgeProjectInvitationsEndpoint(requestExecutor);
  }
}
